import type { FlattenSimpleInterpolation } from 'styled-components'
import s, { css } from 'styled-components'
// @ts-expect-error styled is not typed with default, resolves ESM issue found in Nextjs
const styled: typeof s = typeof s === 'object' && 'default' in s ? s.default : s

import { responsiveSizing } from '@vfuk/core-mixins'

import type { StyledSimpleBadgeProps } from './SimpleBadge.style.types'

export const SimpleBadge = styled.div<StyledSimpleBadgeProps>((props): FlattenSimpleInterpolation => {
  const { color } = props.simpleBadgeTheme.appearance[props.appearance]
  return css`
    ${responsiveSizing('width', 2)};
    ${responsiveSizing('height', 2)};
    border-radius: 50%;
    background-color: ${props.state ? props.theme.color[props.state].default : color};
  `
})
